import TitleDashboard from "@components/general/Titles/TitleDashboard";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { obtenerEstadisticasEstudiante } from "@helpers/httpRequests/httpRequestsGruposLectura/httpRequestsGruposLectura";
import { useState, useMemo, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { Col, Container, Row, Spinner } from "react-bootstrap";

// ─── Datos de ejemplo (reemplaza con tus datos reales) ───────────────────────
const COMPETIDORES_EJEMPLO = [
    { id: 0, nombre: "Dulce Adriana Sanchez Gomez", email: "adrissdul@gmail.com", pct: 77, estado: "active", dias: 8, vel: "280 pal/min", caps: [100, 85, 78, 65, 57] },
    { id: 1, nombre: "Yaneth Fernanda Juarez Medina", email: "yanethmedina99@gmail.com", pct: 62, estado: "active", dias: 7, vel: "245 pal/min", caps: [85, 70, 60, 55, 40] },
    { id: 2, nombre: "Baneza Judith Escalera Hernández", email: "banezaescalerash@gmail.com", pct: 38, estado: "active", dias: 1, vel: "195 pal/min", caps: [60, 45, 35, 20, 30] },
];

const CAPITULOS = ["Cap. 1", "Cap. 2", "Cap. 3", "Cap. 4", "Cap. 5"];

// ─── Helpers ─────────────────────────────────────────────────────────────────
const initials = (name) =>
    name.split(" ").slice(0, 2).map((w) => w[0]).join("").toUpperCase();

const STATUS_MAP = {
    active: { label: "Activo", cls: "status-active" },
    inactive: { label: "Inactivo", cls: "status-inactive" },
    risk: { label: "En riesgo", cls: "status-risk" },
};

// ─── Subcomponentes ───────────────────────────────────────────────────────────

function Avatar({ name, size = 34, fontSize = 12 }) {
    return (
        <div style={{
            width: size, height: size, borderRadius: "50%",
            background: "#00152A", color: "#FF9900",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize, fontWeight: 500, flexShrink: 0,
        }}>
            {initials(name)}
        </div>
    );
}

function ProgressBar({ pct, height = 6 }) {
    const isHigh = pct >= 80;
    return (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{
                flex: 1, height, background: "#e9ecef",
                borderRadius: 10, overflow: "hidden", minWidth: 80,
            }}>
                <div style={{
                    width: `${pct}%`, height: "100%", borderRadius: 10,
                    background: isHigh ? "#00152A" : "#FF9900",
                    transition: "width 0.4s",
                }} />
            </div>
            <span style={{ fontSize: 13, fontWeight: 500, color: "#212529", minWidth: 36, textAlign: "right" }}>
                {pct}%
            </span>
        </div>
    );
}

function StatusPill({ estado }) {
    const { label, cls } = STATUS_MAP[estado] || STATUS_MAP.inactive;
    const styles = {
        "status-active": { background: "#d4edda", color: "#155724" },
        "status-inactive": { background: "#f8f9fa", color: "#6c757d" },
        "status-risk": { background: "#fff3cd", color: "#856404" },
    };
    return (
        <span style={{
            display: "inline-block", padding: "3px 10px",
            borderRadius: 20, fontSize: 11, fontWeight: 500,
            ...styles[cls],
        }}>
            {label}
        </span>
    );
}

function RankBadge({ rank }) {
    const style = rank === 1
        ? { background: "#FF9900", color: "#212529" }
        : rank === 2
            ? { background: "#e9ecef", color: "#495057" }
            : rank === 3
                ? { background: "#ffe8cc", color: "#7a3e00" }
                : { background: "#f8f9fa", color: "#868e96" };
    return (
        <span style={{
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            width: 26, height: 26, borderRadius: 6, fontSize: 12, fontWeight: 500,
            ...style,
        }}>
            {rank}
        </span>
    );
}

function StatCard({ label, value, accent = false }) {
    return (
        <div style={{
            background: "#fff", border: "0.5px solid #dee2e6",
            borderRadius: 10, padding: "14px 16px",
        }}>
            <div style={{ fontSize: 12, color: "#6c757d", marginBottom: 4 }}>{label}</div>
            <div style={{ fontSize: 22, fontWeight: 500, color: accent ? "#FF9900" : "#00152A" }}>
                {value}
            </div>
        </div>
    );
}

// ─── Modal Individual ─────────────────────────────────────────────────────────
const ModalIndividual = ({ competidor, rank, onClose, estadisticasUsuarios }) => {
    // if (!competidor) return null;

    const [dataXComprension, setDataXComprension] = useState([])
    const [dataYComprension, setDataYComprension] = useState([])

    const [dataXVelocidad, setDataXVelocidad] = useState([]);
    const [dataYVelocidad, setDataYVelocidad] = useState([]);



    const estadisticas = estadisticasUsuarios[competidor.id]

    const getTestsSeguimiento = (data) => {
        let array = [];

        for (let index = 0; index < data.length; index++) {
            const element = data[index];

            array.push(`Test ${index + 1}`);

        }

        console.log(array)
        setDataXComprension(array);
    }

    const getDataComprension = (data) => {
        let array = [];

        for (let index = 0; index < data.length; index++) {
            const element = data[index];

            array.push(element.comprention);

        }
        console.log(array)
        setDataYComprension(array)
    }


    const getXDataVelocidad = (data) => {
        let array = [];

        for (let index = 0; index < data.length; index++) {
            const element = data[index];

            array.push(`Test ${index + 1}`);

        }

        console.log(array)
        setDataXVelocidad(array);
    }

    const getYDataVelocidad = (data) => {
        let array = [];

        for (let index = 0; index < data.length; index++) {
            const element = data[index];

            array.push(element.speed);

        }
        console.log(array)
        setDataYVelocidad(array)
    }


    const configComprension = {
        series: [
            {
                name: "Comprensión: ",
                data: dataYComprension,
            },
        ],
        options: {
            colors: ["#ff9900"],
            chart: {
                type: "bar",
                height: 380,
                zoom: {
                    enabled: false,
                },
            },
            xaxis: {
                categories: dataXComprension,
            },

            tooltip: {
                x: {
                    formatter: function (val) {
                        return val;
                    },
                },
            },
        },
    };

    const configVelocidad = {
        series: [
            {
                name: "ppm: ",
                data: dataYVelocidad,
            },
        ],
        options: {
            colors: ["#00152a"],
            chart: {
                type: "bar",
                height: 380,
                zoom: {
                    enabled: false,
                },
            },
            xaxis: {
                categories: dataXVelocidad,
            },

            tooltip: {
                x: {
                    formatter: function (val) {
                        return val;
                    },
                },
            },
        },
    };


    useEffect(() => {
        const handleEstadisticas = () => {
            getTestsSeguimiento(Array.isArray(estadisticas.comprention) ? estadisticas.comprention : [estadisticas.comprention])
            getDataComprension(Array.isArray(estadisticas.comprention) ? estadisticas.comprention : [estadisticas.comprention])

            getXDataVelocidad(Array.isArray(estadisticas.speed) ? estadisticas.speed : [estadisticas.speed])
            getYDataVelocidad(Array.isArray(estadisticas.speed) ? estadisticas.speed : [estadisticas.speed])
        }
        handleEstadisticas();

    }, [])


    return (
        <ModalOverlay onClose={onClose}>
            <div style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 650, overflowY: "scroll", height: "600px" }}>
                {/* Header */}
                <div style={{ background: "#00152A", padding: "20px 24px", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <div style={{
                            width: 48, height: 48, borderRadius: "50%", background: "#FF9900",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            fontSize: 16, fontWeight: 500, color: "#00152A",
                        }}>
                            {initials(competidor.nombre)}
                        </div>
                        <div>
                            <div style={{ fontSize: 16, fontWeight: 500, color: "#fff" }}>{competidor.nombre}</div>
                            <div style={{ fontSize: 12, color: "#adb5bd", marginTop: 2 }}>{competidor.email}</div>
                        </div>
                    </div>
                    <CloseBtn onClose={onClose} />
                </div>

                {/* Body */}
                <div style={{ padding: "20px 24px" }}>
                    <SectionTitle>Resumen</SectionTitle>
                    {/* <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 20 }}>
                        <MiniStat label="Avance total" value={`${competidor.pct}%`} accent />
                        <MiniStat label="Capítulos completados" value={`${competidor.caps.filter(x => x >= 100).length}/${competidor.caps.length}`} />
                        <MiniStat label="Lectura promedio" value={competidor.vel} />
                        <MiniStat label="Racha de días" value={`${competidor.dias} días`} />
                    </div> */}

                    <Container>
                        {
                            (dataXComprension.length > 0 && dataYComprension.length > 0 && dataXVelocidad.length > 0 && dataYVelocidad.length > 0) ? (
                                <>

                                    <Col className='col-12'>
                                        <TitleDashboard title={'Comprensión (%)'} />
                                        <ReactApexChart options={configComprension.options} series={configComprension.series} type="bar" height="350" />
                                    </Col>
                                    <Col className='col-12'>
                                        <TitleDashboard title={'Velocidad de lectura (ppm)'} />
                                        <ReactApexChart options={configVelocidad.options} series={configVelocidad.series} type="bar" height="350" />
                                    </Col>
                                </>
                            ) : (
                                <Row className='mt-3 mb-3'>
                                    <Col className='text-center'>
                                        <FontAwesomeIcon className='mb-3' icon={faBoxOpen} size={'4x'} color="#c0c0c0ff" />
                                        <h3 style={{ color: '#c0c0c0ff' }}>Sin información por mostrar </h3>
                                    </Col>
                                </Row>
                            )
                        }
                    </Container>

                    {/* <SectionTitle>Avance por capítulo</SectionTitle>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {CAPITULOS.map((cap, i) => (
              <div key={cap} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 13, color: "#495057", minWidth: 56 }}>{cap}</span>
                <div style={{ flex: 1, height: 6, background: "#e9ecef", borderRadius: 10, overflow: "hidden" }}>
                  <div style={{ width: `${competidor.caps[i]}%`, height: "100%", background: "#FF9900", borderRadius: 10 }} />
                </div>
                <span style={{ fontSize: 12, color: "#6c757d", minWidth: 34, textAlign: "right" }}>
                  {competidor.caps[i]}%
                </span>
              </div>
            ))}
          </div> */}
                </div>
            </div>
        </ModalOverlay>
    );
}

// ─── Modal General ────────────────────────────────────────────────────────────
function ModalGeneral({ competidores, onClose }) {
    const sorted = [...competidores].sort((a, b) => b.pct - a.pct);
    const avg = Math.round(sorted.reduce((a, c) => a + c.pct, 0) / sorted.length);
    const completos = sorted.filter(c => c.pct === 100).length;

    return (
        <ModalOverlay onClose={onClose}>
            <div style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 560, overflow: "hidden" }}>
                {/* Header */}
                <div style={{ background: "#00152A", padding: "20px 24px", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <div style={{ width: 48, height: 48, borderRadius: "50%", background: "#FF9900", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <IconChart />
                        </div>
                        <div>
                            <div style={{ fontSize: 16, fontWeight: 500, color: "#fff" }}>Avance general</div>
                            <div style={{ fontSize: 12, color: "#adb5bd", marginTop: 2 }}>Todos los competidores</div>
                        </div>
                    </div>
                    <CloseBtn onClose={onClose} />
                </div>

                {/* Body */}
                <div style={{ padding: "20px 24px" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 20 }}>
                        <MiniStat label="Líder actual" value={sorted[0]?.nombre.split(" ")[0]} accent />
                        <MiniStat label="Promedio grupal" value={`${avg}%`} accent />
                        <MiniStat label="Completaron todo" value={completos} />
                        <MiniStat label="En progreso" value={sorted.length - completos} />
                    </div>

                    <SectionTitle>Ranking de avance</SectionTitle>
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                        {sorted.map((c, i) => (
                            <div key={c.id} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                <span style={{ fontSize: 13, color: "#212529", fontWeight: 500, minWidth: 130, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {c.nombre}
                                </span>
                                <div style={{ flex: 1, height: 10, background: "#e9ecef", borderRadius: 10, overflow: "hidden" }}>
                                    <div style={{ width: `${c.pct}%`, height: "100%", borderRadius: 10, background: i === 0 ? "#FF9900" : "#00152A", transition: "width 0.4s" }} />
                                </div>
                                <span style={{ fontSize: 13, fontWeight: 500, color: "#212529", minWidth: 36, textAlign: "right" }}>
                                    {c.pct}%
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </ModalOverlay>
    );
}

// ─── Helpers UI ───────────────────────────────────────────────────────────────
function ModalOverlay({ children, onClose }) {
    return (
        <div
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
            style={{
                position: "fixed", inset: 0, background: "rgba(0,21,42,0.55)",
                zIndex: 1000, display: "flex", alignItems: "center",
                justifyContent: "center", padding: 20,
            }}
        >
            {children}
        </div>
    );
}

function CloseBtn({ onClose }) {
    return (
        <button
            onClick={onClose}
            style={{ background: "none", border: "none", color: "#adb5bd", fontSize: 20, cursor: "pointer", padding: 0, lineHeight: 1 }}
        >
            ✕
        </button>
    );
}

function SectionTitle({ children }) {
    return (
        <div style={{ fontSize: 11, fontWeight: 500, color: "#adb5bd", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 12 }}>
            {children}
        </div>
    );
}

function MiniStat({ label, value, accent = false }) {
    return (
        <div style={{ background: "#f8f9fa", borderRadius: 8, padding: 12 }}>
            <div style={{ fontSize: 11, color: "#6c757d", marginBottom: 4 }}>{label}</div>
            <div style={{ fontSize: 18, fontWeight: 500, color: accent ? "#FF9900" : "#00152A" }}>{value}</div>
        </div>
    );
}

function IconChart() {
    return (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#00152A" strokeWidth="2">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
        </svg>
    );
}

// ─── Componente Principal ─────────────────────────────────────────────────────
/**
 * LecturaInteligente
 *
 * Props:
 *   competidores  – array de objetos competidor (opcional; usa datos de ejemplo si se omite)
 *   capitulos     – array de strings con los nombres de capítulos (opcional)
 *
 * Forma del objeto competidor:
 * {
 *   id: number | string,
 *   nombre: string,
 *   email: string,
 *   pct: number,           // 0-100  avance total
 *   estado: "active" | "inactive" | "risk",
 *   dias: number,          // racha de días activos
 *   vel: string,           // velocidad de lectura (texto libre)
 *   caps: number[],        // avance por capítulo (0-100) — debe coincidir con `capitulos`
 * }
 */
export default function LecturaInteligente({
    competidores = COMPETIDORES_EJEMPLO,
    capitulos = CAPITULOS,
}) {
    const [busqueda, setBusqueda] = useState("");
    const [modalIndividual, setModalIndividual] = useState(null); // competidor seleccionado
    const [modalGeneral, setModalGeneral] = useState(false);
    const [estadisticas, setEstadisticasUsuarios] = useState([]);
    const [showLoader, setShowLoader] = useState(false);

    const sorted = useMemo(
        () => [...competidores].sort((a, b) => b.pct - a.pct),
        [competidores]
    );

    const filtrados = useMemo(() => {
        const q = busqueda.toLowerCase();
        return sorted.filter(
            (c) => c.nombre.toLowerCase().includes(q) || c.email.toLowerCase().includes(q)
        );
    }, [busqueda, sorted]);

    const avg = Math.round(sorted.reduce((a, c) => a + c.pct, 0) / sorted.length);
    const activos = sorted.filter((c) => c.estado === "active").length;

    const rankOf = (c) => sorted.indexOf(c) + 1;

    const promecdioComprensionLectura = (informacionUsuarios) => {



    }

    useEffect(() => {
        //Obtener las estadisticas de todos los alumnos.
        const obtenerEstadisticas = async () => {
            try {
                setShowLoader(true);
                const data = await obtenerEstadisticasEstudiante({ listaUsuarios: COMPETIDORES_EJEMPLO });
                console.log(data);



                setEstadisticasUsuarios(data);
                setShowLoader(false);

            } catch (error) {
                console.log(error);
                setShowLoader(false);

            }
        }
           obtenerEstadisticas();
    }, []);

    return (
        <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", padding: "1.5rem", background: "transparent" }}>
            {/* ── Header ── */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.5rem", flexWrap: "wrap", gap: 12 }}>
                <div>
                    <span style={{
                        display: "inline-block", background: "#FF9900", color: "#212529",
                        fontSize: 11, fontWeight: 500, padding: "3px 10px", borderRadius: 20,
                        letterSpacing: "0.04em", marginBottom: 6,
                    }}>
                        Concurso en línea
                    </span>
                    <div style={{ fontSize: 20, fontWeight: 500, color: "#00152A" }}>Lectura Inteligente</div>
                    <div style={{ fontSize: 13, color: "#6c757d" }}>Panel de competidores</div>
                </div>

                {/* <button
                    onClick={() => setModalGeneral(true)}
                    style={{
                        display: "flex", alignItems: "center", gap: 8,
                        background: "#00152A", color: "#fff", border: "none",
                        borderRadius: 8, padding: "10px 18px", fontSize: 14, fontWeight: 500,
                        cursor: "pointer",
                    }}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                    </svg>
                    Ver avance general
                </button> */}
            </div>

            {/* ── Stats ── */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12, marginBottom: "1.5rem" }}>
                <StatCard label="Total competidores" value={sorted.length} />
                {/* <StatCard label="Promedio avance"    value={`${avg}%`}     accent /> */}
                <StatCard label="Activos" value={activos} />
            </div>

            {showLoader ? (

                <Row className='justify-content-center'>
                    <Col className="col-auto text-center">
                        <Spinner color='#ff9900' animation={'border'} />
                        <p>Cargando...</p>
                    </Col>
                </Row>
            ) : (

                <>
                    {/* ── Tabla ── */}
                    <div style={{ background: "#fff", border: "0.5px solid #dee2e6", borderRadius: 12, overflow: "hidden" }}>
                        {/* Panel header */}
                        <div style={{
                            display: "flex", alignItems: "center", justifyContent: "space-between",
                            padding: "14px 20px", borderBottom: "0.5px solid #dee2e6",
                            background: "#f8f9fa", flexWrap: "wrap", gap: 10,
                        }}>
                            <div style={{ fontSize: 15, fontWeight: 500, color: "#00152A" }}>Competidores</div>
                            <input
                                value={busqueda}
                                onChange={(e) => setBusqueda(e.target.value)}
                                placeholder="Buscar competidor..."
                                style={{
                                    border: "0.5px solid #dee2e6", borderRadius: 6, padding: "6px 12px",
                                    fontSize: 13, color: "#212529", background: "#fff",
                                    width: 200, outline: "none",
                                }}
                            />
                        </div>

                        {/* Tabla */}
                        <div style={{ overflowY: "scroll", height: "500px", marginBottom: "50px" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse", height: "50%" }}>
                                <thead>
                                    <tr>
                                        {["#", "Competidor", "Estado", "Acción"].map((h, i) => (
                                            <th key={i} style={{
                                                fontSize: 12, fontWeight: 500, color: "#6c757d", textAlign: "left",
                                                padding: "12px 20px", borderBottom: "0.5px solid #dee2e6",
                                                background: "#f8f9fa", textTransform: "uppercase", letterSpacing: "0.04em",
                                                width: i === 0 ? 40 : i === 4 ? 100 : undefined,
                                            }}>
                                                {h}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filtrados.map((c) => {
                                        const rank = rankOf(c);
                                        return (
                                            <tr key={c.id} style={{ borderBottom: "0.5px solid #f1f3f5" }}>
                                                <td style={{ padding: "13px 20px" }}>{rank}</td>
                                                <td style={{ padding: "13px 20px" }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                        <Avatar name={c.nombre} />
                                                        <div>
                                                            <div style={{ fontWeight: 500, color: "#212529", fontSize: 14 }}>{c.nombre}</div>
                                                            <div style={{ fontSize: 12, color: "#adb5bd" }}>{c.email}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                {/* <td style={{ padding: "13px 20px", minWidth: 160 }}>
                        <ProgressBar pct={c.pct} />
                        </td> */}
                                                <td style={{ padding: "13px 20px" }}><StatusPill estado={c.estado} /></td>
                                                <td style={{ padding: "13px 20px" }}>
                                                    <button
                                                        onClick={() => setModalIndividual(c)}
                                                        style={{
                                                            background: "transparent", border: "0.5px solid #00152A",
                                                            color: "#00152A", borderRadius: 6, padding: "6px 14px",
                                                            fontSize: 12, fontWeight: 500, cursor: "pointer",
                                                            display: "flex", alignItems: "center", gap: 5,
                                                        }}
                                                    >
                                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                                            <circle cx="12" cy="12" r="3" />
                                                        </svg>
                                                        Ver avance
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    {filtrados.length === 0 && (
                                        <tr>
                                            <td colSpan={5} style={{ padding: "32px 20px", textAlign: "center", color: "#adb5bd", fontSize: 14 }}>
                                                No se encontraron competidores.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* ── Modales ── */}
                    {modalIndividual && (
                        <ModalIndividual
                            competidor={modalIndividual}
                            rank={rankOf(modalIndividual)}
                            onClose={() => setModalIndividual(null)}
                            estadisticasUsuarios={estadisticas}
                        />
                    )}
                    {modalGeneral && (
                        <ModalGeneral
                            competidores={competidores}
                            onClose={() => setModalGeneral(false)}
                        />
                    )}
                </>
            )}

        </div>
    );
}